export type BlockType =
  | "accordion"
  | "callToAction"
  | "cardGallery"
  | "eventCard"
  | "features"
  | "gallerySlider"
  | "gridBlock"
  | "gridBlockV2"
  | "leaderBoard"
  | "mainBanner" // V2 (guard `isMainBanner` без суффикса)
  | "mainBannerV3"
  | "mainBannerV4"
  | "mainSlider"
  | "pageBreadcrumbs"
  | "pageLinks"
  | "paymentMethods"
  | "reviewSlider"
  | "rowSlider"
  | "rowTabs"
  | "schedule"
  | "socialNetworks"
  | "spacer"
  | "steps"
  | "textAndImage"
  | "textBlock"
  | "textHighlighter"
  | "textWithAnchors"
  | "welcomeOfferBanner";

export const BLOCK_MIN_HEIGHTS: Record<
  BlockType,
  { mobile: number; tablet: number; desktop: number }
> = {
  // Banner (hero) category — large above-fold blocks
  mainBanner: { mobile: 480, tablet: 540, desktop: 600 },
  mainBannerV3: { mobile: 480, tablet: 540, desktop: 600 },
  mainBannerV4: { mobile: 480, tablet: 540, desktop: 600 },
  welcomeOfferBanner: { mobile: 480, tablet: 540, desktop: 600 },

  // Slider/carousel category
  rowSlider: { mobile: 320, tablet: 380, desktop: 420 },
  mainSlider: { mobile: 320, tablet: 380, desktop: 420 },
  gallerySlider: { mobile: 320, tablet: 380, desktop: 420 },
  reviewSlider: { mobile: 320, tablet: 380, desktop: 420 },

  // Grid/gallery category — multi-cell content
  gridBlock: { mobile: 360, tablet: 420, desktop: 480 },
  gridBlockV2: { mobile: 360, tablet: 420, desktop: 480 },
  cardGallery: { mobile: 360, tablet: 420, desktop: 480 },
  paymentMethods: { mobile: 360, tablet: 420, desktop: 480 },

  // Text content category
  textBlock: { mobile: 200, tablet: 240, desktop: 280 },
  textWithAnchors: { mobile: 200, tablet: 240, desktop: 280 },
  textHighlighter: { mobile: 200, tablet: 240, desktop: 280 },
  textAndImage: { mobile: 200, tablet: 240, desktop: 280 },

  // Compact/list category
  accordion: { mobile: 240, tablet: 300, desktop: 360 },
  features: { mobile: 240, tablet: 300, desktop: 360 },
  steps: { mobile: 240, tablet: 300, desktop: 360 },
  eventCard: { mobile: 240, tablet: 300, desktop: 360 },
  callToAction: { mobile: 240, tablet: 300, desktop: 360 },
  pageLinks: { mobile: 240, tablet: 300, desktop: 360 },

  // Data table category — heavy content
  leaderBoard: { mobile: 480, tablet: 540, desktop: 600 },
  schedule: { mobile: 480, tablet: 540, desktop: 600 },

  // Navigation category — compact
  pageBreadcrumbs: { mobile: 80, tablet: 80, desktop: 80 },
  rowTabs: { mobile: 80, tablet: 80, desktop: 80 },
  socialNetworks: { mobile: 80, tablet: 80, desktop: 80 },

  // Layout category
  spacer: { mobile: 60, tablet: 60, desktop: 60 },
};
